// This module is responsible for adding or removing the transition class that could trigger css animations 
function init($elements = null) {
    if(!$elements.length) return;

    $elements.forEach($element => {
        // Remove the transition class
        $element.classList.remove('animation-block-transition');
            
        // Create the observer, same as before:
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    $element.classList.add('animation-block-transition');
                    return;
                }

                $element.classList.remove('animation-block-transition');
            });
        });

        observer.observe($element.closest('.animation-block-wrapper') );
    })
}

init(document.querySelectorAll('.animation-block'))